import { useContext } from "react";
import { BackgroundContext } from "../contexts/BackgroundContext";

const useBackground = () => useContext(BackgroundContext);

export default useBackground;
